import React, { Component } from "react";
import LoaderSpinner from "../../componentes/LoaderSpinner";
import TableEmails from './TableEmails'
import request from "superagent";
import { defaultPaperPadding, url_endpoint } from "../../config";
import authHeader from '../Utils/AuthHeader';
import DateRangePickers from "./Dashboard/components/DateRangePickers";
import moment from 'moment';
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import { ExportToCsv } from 'export-to-csv';
import checkLogin from "../Utils/checkLogin";
import palette from "../../theme/palette";
import profileIcon from '../../images/icons/profile_icon.svg'
import ImageIconBox from './components/ImageIconBox'

class Leads extends Component {
    constructor(props) {
        super(props)

        this.props.setTitulo('Leads')

        this.state = {
            loading: false,
            listaEpisodios: [],
            listaEmails: [],
            dataInicio: Date.now(),
            dataFim: Date.now()
        }
    }

    async componentDidMount() {
        await checkLogin(false)
        this.setState({ loading: true })

        const res = await request.get(url_endpoint + "podcast/all/").set(authHeader());
        res.body.forEach(element => {
            this.state.listaEpisodios.push({ id: element.id, titulo: element.titulo });
        });

        this.getEmails()
    }

    getEmails = () => {
        this.setState({ loading: true })
        try {
            const listaEps = this.state.listaEpisodios
            const listaEm = []
            request.get(url_endpoint + 'playerview/range/' + this.state.dataInicio + '/' + this.state.dataFim + '/email/').set(authHeader())
                .end((err, res) => {
                    console.log(res.body)
                    res.body.forEach(function (childSnapshot) {
                        console.log(childSnapshot)
                        const postcastAtual = listaEps.find((elem) => elem.id == childSnapshot.postcastId)
                        listaEm.push({ data: childSnapshot.dateAcesso, titulo: postcastAtual != undefined ? postcastAtual.titulo : 'Fonte desconhecida', email: childSnapshot.email })
                    });
                    this.setState({ listaEmails: listaEm, loading: false })
                });
        }
        catch (e) {
            console.log(e)
        }
    }

    changerangedata = async (startDate, endDate) => {
        let dataInicio = moment(startDate).startOf('day').toDate().getTime();
        let dataFim = moment(endDate).startOf('day').toDate().getTime();

        if (dataFim - dataInicio >= 604800000) {
            window.alert('O período máximo é de 7 dias.')
        }
        else {
            await this.setState({ dataInicio: dataInicio, dataFim: dataFim });
            this.getEmails();
        }
    }

    generateCSV = () => {
        this.setState({ loading: true })
        try {
            const listaEps = this.state.listaEpisodios
            let data = []
            request.get(url_endpoint + 'playerview/range/' + (Date.now() - 2592000000) + '/' + Date.now() + '/email/').set(authHeader())
                .end((err, res) => {
                    if (res.body.length <= 0) {
                        window.alert('Não existem dados nos últimos 30 dias.')
                    }
                    else {
                        res.body.forEach(function (childSnapshot) {
                            const postcastAtual = listaEps.find((elem) => elem.id == childSnapshot.postcastId)
                            data.push({ data: moment(childSnapshot.dateAcesso).format('DD/MM/YYYY'), ' ': '', titulo: postcastAtual.titulo, '  ': '', email: childSnapshot.email })
                        });
                        const options = {
                            fieldSeparator: ',',
                            quoteStrings: '"',
                            decimalSeparator: '.',
                            showLabels: true,
                            useTextFile: false,
                            useBom: true,
                            useKeysAsHeaders: true,
                            filename: 'EmailsBlogPlay'
                        };

                        const csvExporter = new ExportToCsv(options);

                        csvExporter.generateCsv(data);
                    }
                });
        }
        catch (e) {
            console.log(e)
        }
        this.setState({ loading: false })
    }

    render() {
        return (
            <div>
                <div>
                    {this.state.loading && <LoaderSpinner />}
                </div>
                <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
                    <h2 style={{ color: palette.primary.main }}>Leads</h2>
                    <Button onClick={() => { if (window.confirm('O CSV irá gerar com os emails dos últimos 30 dias. Deseja gerar o CSV?')) this.generateCSV() }} variant="contained" color="primary" component="span">Baixar CSV</Button>
                </div>
                <Paper style={{ padding: defaultPaperPadding }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <ImageIconBox size='50px' padding='10px' src={profileIcon}></ImageIconBox>
                        <DateRangePickers changerangedata={this.changerangedata}></DateRangePickers>
                    </div>
                    <TableEmails listaEpisodios={this.state.listaEmails}></TableEmails>
                </Paper>
            </div>
        )
    }
}

export default Leads